import { render, staticRenderFns } from "./operateVideo.vue?vue&type=template&id=48497089&scoped=true&"
import script from "./operateVideo.vue?vue&type=script&lang=js&"
export * from "./operateVideo.vue?vue&type=script&lang=js&"
import style0 from "./operateVideo.vue?vue&type=style&index=0&id=48497089&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48497089",
  null
  
)

export default component.exports